module.exports = __webpack_public_path__ + "static/GalanoGrotesque-Light-2e76e5a0fe740cd664c54bf439c877e0.eot";